<!--bug反馈 -->
<template>
	<div class="public-trends">
		<div><span class="color-red">*</span>标题</div>
		<el-input class="mt-2" type="text" v-model="postName" placeholder="请输入Bug标题"/>
		<div class="mt-2"><span class="color-red">*</span>操作步骤</div>
		<el-input
			class="mt-1"
			type="textarea"
			:rows="15"
			:minlength="15"
			placeholder="请分步骤描述在出现问题前进行了什么操作，建议添加图片或录屏辅助说明，更完整的操作步骤有助于开发同学更快定位问题哦。如:1.打开文件管理2.选择文档添加周片/短视频"
			v-model="operStep">
		</el-input>
		<UploadImg class="mt-2" @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/>
		<div class="mt-2">预期结果</div>
		<el-input
			class="mt-1"
			type="textarea" v-model="expectResult" placeholder="请描述您预期的操作结果"/>
		<div class="mt-2">实际结果</div>
		<el-input
			class="mt-1"
			type="textarea" v-model="actualResult" placeholder="请描述您实际的操作结果"/>
		<div class="mt-2">其他信息</div>
		<el-input
			class="mt-1"
			type="textarea" v-model="otherResult" placeholder="其他信息在此处备注"/>
		<div class="select">
			<el-form label-position="top">
				<el-form-item label="选择圈子">
					<el-cascader
						:options="options"
						:props="{ value: 'id', label: 'value', expandTrigger: 'hover' }"
						popper-class="circle-cascader-popper"
						v-model="selectedOptions"
						@change="handleChange">
					</el-cascader>
				</el-form-item>
			</el-form>
		</div>
		<div class="btns">
			<a @click="toCancel" href="javascript:;">取消</a>
			<a @click="publicClick" href="javascript:;" class="active">发布</a>
		</div>
	</div>
</template>

<script>
	import UploadImg from '@/components/upload'
	import postCateModules from '@/modules/postCategory.js'
	import { post, ajaxParam } from '@/units/request.js'
	import qs from 'qs'
	export default {
		name: 'publicTrends',
		components: {
			UploadImg
		},
		data() {
			return {
				userId: '',
				options: [],
        selectedOptions: [],
				operStep: '',
				uploadFileUrl: [],
				categoryId: '',
				circleId: '',
				circleList: [],
				circleClassifyId:'',
				talkId:'',
				title: '',
				postStatus: 1, // 0草稿，1发布
				picUrls: '',
				postName: '',
				actualResult:'',
				expectResult: '',
				otherResult: ''
			}
		},
		props: {
			item: {
				type: Object,
				value: ''
			},
			postType:  {
				type: Number,
				value: 2
			},
		},
		mixins:[
			postCateModules
		],
		watch: {
			// title(newVal){
			// 	console.log(newVal)
			// 	this.titleLength = 30-newVal.length
			// 	if(this.titleLength<=0) {
			// 		this.titleLength = 0
			// 	}
			// },
			postType(){
				console.log(this.postType,11111)
			},
			uploadFileUrl(newVal, oldVal){
				console.log('变')
				if(newVal.length>0){
					this.picUrls = newVal.join(',')
					console.log(this.picUrls)
				}
			}
		},
		created() {
			this.userId = localStorage.getItem('userId')||''
			this.getCircleCategory()
		},
		methods: {
			// 选择圈子
			handleChange(e){
				// 二级级联：[分类ID, 圈子ID]
				// 确保 circleId 始终为圈子ID（第2层），分类下无圈子时置 null 由校验拦截
				const len = this.selectedOptions.length
				if (len >= 2) {
					this.circleId = this.selectedOptions[1]
				} else {
					this.circleId = null
				}
				// 二级接口无标签层，categoryId 恒为 null
				this.categoryId = null
			},
			toCancel(e){
				this.$emit('toCancel')
			},
			uploadSuccess(e){
				console.log('success')
				console.log(e.uploadFileList)
				this.uploadFileUrl = e.uploadFileList
			},
			uploadDelete(e){
				let a = []
				e.uploadFileList.forEach(item=>{
					a.push(item.response.entity.fileUrl)
				})
				this.uploadFileUrl = a
			},
			changeTalkPost(e){
				this.talkId = e
				console.log(e)
			},
			// 获取圈子二级列表（反馈只需要选择圈子，不需要帖子分类）
			async getCircleCategory(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircleOtherTwoLevel', qs.stringify(param))
				if(res.data.code==200){
					this.options = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//发布
			async publicClick(){
				if(!this.postName) {
					this.$message.error('请输入标题')
					return
				}
				if(!this.operStep || this.operStep.length < 15) {
					this.$message.error('操作步骤不能少于15个字')
					return
				}

				if(!this.circleId) {
					this.$message.error('请选择圈子')
					return
				}
				let param = {
				userId: this.userId,
				circleId: this.circleId,
				categoryId: this.categoryId,
				talkId: this.talkId,
				postName: this.postName,
				picUrls: this.picUrls,
				operStep: this.operStep,
				postType: this.postType,
				postStatus: this.postStatus,
				expectResult: this.expectResult,
				actualResult: this.actualResult,
				otherResult: this.otherResult
			}
				console.log(param, 11111)
				ajaxParam(param)
				const res = await post('v1/circle/addPost', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success(res.data.msg||'操作成功!')
					this.$emit('toCancel')
					this.$router.push({
						path: '/publicManage'
					})
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	::v-deep .el-form--label-top .el-form-item__label{
		padding:0;
	}
	.public-trends{
		margin-top: -20px;
	}
	.content{
		width: 100%;
		margin-bottom: 15px;
		padding: 10px;
		border-color: #DBDCDC;
		box-sizing: border-box;
		border-radius: 4px;
	}
	/deep/ .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .el-upload--picture-card {
		width: 70px;
		height: 70px;
		line-height: 70px;
	}
	.select{
		.el-form{
			display: flex;
			justify-content: space-between;
			.el-form-item{
				flex: 1;
				/deep/ .el-form-item__content{
					line-height: 30px;
				}
				/deep/ .el-input__inner{
					height: 30px;
					line-height: 30px;
				}
				/deep/ .el-input__icon{
					line-height: 30px;
				}
			}

		}
	}
	.btns{
		display: flex;
		justify-content: space-between;
		a{
			display: block;
			width: 45%;
			height: 34px;
			margin-left: 15px;
			background: rgba(50,50,50,.1);
			border-radius: 16px;
			line-height: 34px;
			text-align: center;
		}
		a:hover, a.active{
			background: #DD0515;
			color: #fff;
		}
	}
</style>
